import { useEffect, useState } from "react";
import {
    updateNewPassword,
    showToast,
    useAppDispatch,
} from "@hypexone/uicore";
import ChangePasswordTab from "./ChangePasswordTab";

const ChangePassword = () => {
    const dispatch = useAppDispatch();
    const [confirmPassword, setConfirmPassword] = useState("");
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [disable, setDisable] = useState(false);

    const handleUpdatePassword = () => {
        if (newPassword !== confirmPassword) {
            dispatch(
                showToast({
                    message: `New password and confirm password didn't match.`,
                    type: "error",
                })
            );
            return;
        }
        dispatch(updateNewPassword({ newPassword, oldPassword }));
    };



   
    return (
        <div className="flex flex-col mt-1 bg-white  h-full sm:border rounded-[4px] text-[15px]">
            <div
                className={`py-[2px] flex bg-black1 text-[14px] font-[700] flex-row justify-between items-center  w-full text-white px-2 `}
            >
                <div>
                    <p className="text-[14px]">Change Password</p>
                </div>
            </div>
            <ChangePasswordTab
                oldPassword={oldPassword}
                newPassword={newPassword}
                confirmPassword={confirmPassword}
                updateNewPassword={handleUpdatePassword}
                setOldPassword={setOldPassword}
                setNewPassword={setNewPassword}
                setConfirmPassword={setConfirmPassword}
                disable={disable}
            />
        </div>
    );
};

export default ChangePassword;
